/**
 * Types for Experiment Circuit Breaker
 */

/**
 * Circuit breaker layers with descriptive names
 */
export enum CircuitBreakerLayer {
  /** Debug override (URL param or ModHeader) - bypasses all checks */
  OVERRIDE = 'Override',
  /** Tenant configuration whitelist check */
  TENANT_CONFIG = 'TenantConfig',
  /** GrowthBook payload condition check */
  PAYLOAD_CONDITION = 'PayloadCondition',
  /** GrowthBook evaluation (targeting & rollout) */
  GROWTHBOOK_EVALUATION = 'GrowthBookEvaluation'
}

/**
 * Result of a circuit breaker layer evaluation
 */
export interface CircuitBreakerResult {
  /** Whether to show the variation */
  allowed: boolean;
  /** The variation ID (0 = control, 1 = variation) */
  variationId: number;
  /** Which layer made the decision */
  layer: CircuitBreakerLayer;
  /** Human-readable reason for the decision */
  reason: string;
  /** Whether the experiment is enabled in tenant config */
  isEnabledForTenant: boolean;
}
